import { StockAvailabilityStatus } from '@/components/StockAvailability';
import { StockAvailabilityType } from '@/enums/StockAvailabilityType';
import StockAvailabilityDictionary from '@/types/dictionaries/StockAvailability';
/**
 * Determines real-time stock availability for B2B shops.
 */
export function getRealTimeStockAvailability({
	quantity,
	isBuiltToOrder,
	stockAvailabilityDict,
}: {
	quantity?: number | null;
	isBuiltToOrder?: boolean | null;
	stockAvailabilityDict: StockAvailabilityDictionary;
}): StockAvailabilityStatus {
	if (isBuiltToOrder) {
		return {
			key: StockAvailabilityType.BUILD_TO_ORDER,
			label: stockAvailabilityDict[StockAvailabilityType.BUILD_TO_ORDER],
		};
	}

	if (quantity == null || quantity === 0) {
		return {
			key: StockAvailabilityType.OUT_OF_STOCK,
			label: stockAvailabilityDict[StockAvailabilityType.OUT_OF_STOCK],
		};
	}

	return {
		key: StockAvailabilityType.IN_STOCK,
		label: stockAvailabilityDict[StockAvailabilityType.IN_STOCK],
	};
}
/**
 * Gets configured or default stock availability for D2C shops.
 */
export function getConfiguredOrDefaultStockAvailability({
	stockStatus,
	stockAvailabilityDict,
	showInStockByDefault,
}: {
	stockStatus?: string | null;
	stockAvailabilityDict: StockAvailabilityDictionary;
	showInStockByDefault?: boolean;
}): StockAvailabilityStatus {
	const key = stockStatus?.trim();

	if (key === StockAvailabilityType.HIDE_STOCK_LABEL) return null;

	if (!key) {
		if (!showInStockByDefault) return null;

		return {
			key: StockAvailabilityType.IN_STOCK,
			label: stockAvailabilityDict[StockAvailabilityType.IN_STOCK],
		};
	}

	return {
		key: key as StockAvailabilityType,
		label: stockAvailabilityDict[key as keyof StockAvailabilityDictionary],
	};
}

export const getLeadTimeRange = (
	stockAvailabilityEnabled: boolean,
	leadTime: number | null | undefined,
): string | null => {
	if (!stockAvailabilityEnabled || leadTime == null) {
		return null;
	}

	const lowerBound = Math.ceil(leadTime / 5);
	const upperBound = lowerBound + 1;

	return `${lowerBound} to ${upperBound}`;
};
export { StockAvailabilityType };
